<div>
  <button
    matSuffix
    mat-icon-button
    color="primary"
    aria-label="swap profile"
    i18n-aria-label="@@swapProfileLabel"
    (click)="onSwapLibrary()"
    i18n-matTooltip="@@swapProfileTooltip"
    matTooltip="Switch to another profile"
    [matTooltipShowDelay]="1000"
    [disabled]="currentLibraryId === 0 || (librariesCount$ | async)"
  >
    <mat-icon class="swap-button">swap_horiz</mat-icon>
  </button>
</div>
